const initializeMaxLength = () => {
  $(".js-max-length").maxlength({
    alwaysShow: true,
    warningClass: "badge bg-success",
    limitReachedClass: "badge bg-danger",
  });
};

export default initializeMaxLength;
